// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"0084fba1","587":"f47d7051"}[chunkId] + ".1792741975743.chunk.js";
};